<template>
  <div class="header-mobile-bottom-section__wrapper">
    <ul class="header-mobile-bottom-section__list">
      <header-mobile-bottom-section-item
        v-for="item in items"
        :key="item.name"
        :item="item"
        :tag="$options.consts.HTML_TAG.LI"
        class="header-mobile-bottom-section__list-item-wrapper"
        @click="onItemClick(item)"
      />
    </ul>
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import { ICON } from 'shared/AIcon/index.vue'
import { ROUTE_NAME } from 'enums/routes'
import HeaderMobileBottomSectionItem from '@/components/AHeader/AHeaderMobile/AHeaderMobileBottomSection/HeaderMobileBottomSectionItem/index.vue'
import { HTML_TAG } from '@fmpedia/enums'
import { HEADER_MOBILE_MENU_OPEN_BTN_ATTRIBUTE } from 'enums/data-attributes'

export default {
  name: 'AHeaderMobileBottomSection',
  components: { HeaderMobileBottomSectionItem },
  model: {
    prop: 'isMenuExpanded'
  },
  props: {
    isMenuExpanded: propValidator([PROP_TYPES.BOOLEAN])
  },
  consts: {
    HTML_TAG
  },
  data() {
    return {
      items: [
        {
          icon: ICON.MENU_NEWS,
          name: 'Live Feed',
          link: {
            name: ROUTE_NAME.LIVE_FEED
          }
        },
        {
          icon: ICON.MENU_BROKERS,
          name: 'Brokers',
          link: {
            name: ROUTE_NAME.BROKERS
          }
        },
        {
          icon: ICON.LIVEBYTES,
          name: 'Livebytes',
          handler: this.openLiveBytesModal
        },
        {
          icon: ICON.BURGER_MENU_PURPLE,
          name: 'More',
          handler: this.openMenu,
          attributes: {
            [HEADER_MOBILE_MENU_OPEN_BTN_ATTRIBUTE]: true
          }
        }
      ]
    }
  },
  methods: {
    openMenu() {
      this.$emit('input', true)
    },
    openLiveBytesModal() {
      this.$bus.$emit('open-modal-livebytes')
    },
    onItemClick(item) {
      if (item.handler) {
        item.handler()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-mobile-bottom-section__wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: $height-header-bottom-menu;
  padding: 0 24px;
  background: $c--black;

  .header-mobile-bottom-section__list {
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .header-mobile-bottom-section__list-item-wrapper {
    display: flex;
  }
}
</style>
